/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

/**
 * resolutions of thumbnails
 */
export type ThumbnailResolution = (typeof ThumbnailResolution)[keyof typeof ThumbnailResolution];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ThumbnailResolution = {
  small: 'small',
  medium: 'medium',
  large: 'large',
} as const;
